export default __webpack_public_path__ + "static/media/9b.fe681ef5.png";